@if (isVisible()) {
  @if (variant() === 'card') {
    <mwe-basic-card>
      <ng-container *ngTemplateOutlet="content" />
    </mwe-basic-card>
  }
  @if (variant() === 'outline') {
    <div class="border border-2 border-secondary-light p-4 rounded-3">
      <ng-container *ngTemplateOutlet="content" />
    </div>
  }
  @if (variant() === 'plain') {
    <ng-container *ngTemplateOutlet="content" />
  }
}

<ng-template #content>
  <div class="inline-size">
    <div class="row g-4">
      @if (staticImage()) {
        <div class="col-above-600-auto col-below-600-12">
          <img [attr.src]="staticImagePath()" alt="" class="d-block mx-auto rounded-2 w-100 h-auto" style="max-width: 280px" />
        </div>
      }
      <div class="col-above-600">
        <div [ngClass]="alignmentClass()">
          <mwe-headline [text]="headlineText()" [headlineNodeType]="headingNodeType()" [cssClass]="'h5'" />
          @if (messageKeys()) {
            @for (key of messageKeys(); track key) {
              <p class="mb-4" [innerHTML]="key | translate: translateValues() | safeHtml"></p>
            }
          }
          <ng-content />
        </div>
        <div class="row g-3" [ngClass]="rowAlignmentClass()">
          @if (ctaLabel()) {
            <div class="col-auto">
              <mwe-button
                [labelKey]="ctaLabel()"
                size="md"
                category="secondary"
                [color]="ctaColor()"
                (clicked)="ctaClick.emit()"
                data-test="teaser-cta-button"
              />
            </div>
          }
          @if (showCloseBtn()) {
            <div class="col-auto">
              <mwe-button labelKey="Schließen" size="md" category="tertiary" [color]="ctaColor()" (clicked)="onCloseButton()" />
            </div>
          }
        </div>
      </div>
      @if (staticImageRight()) {
        <div class="col-above-600-auto col-below-600-12">
          <img [attr.src]="staticImageRightPath()" alt="" class="d-block mx-auto rounded-2 w-100 h-auto" style="max-width: 280px" />
        </div>
      }
    </div>
  </div>
</ng-template>
